var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame10(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5773 16.2439L18.0453 13.7119C17.8443 13.5058 17.5938 13.3546 17.3177 13.2728C17.0416 13.191 16.7491 13.1814 16.4682 13.2449C16.1873 13.3084 15.9274 13.4429 15.7133 13.6355C15.4993 13.8281 15.3381 14.0723 15.2453 14.3449C15.1009 14.7361 14.8196 15.0616 14.4535 15.2611C14.0874 15.4606 13.6613 15.5206 13.2543 15.4299C12.1733 15.0406 11.1916 14.4176 10.3792 13.6051C9.56673 12.7927 8.94364 11.8109 8.55434 10.7299C8.44364 10.3225 8.49447 9.888 8.69623 9.51708C8.89799 9.14616 9.23512 8.86741 9.63734 8.73894C9.90995 8.64617 10.1542 8.48504 10.3468 8.27094C10.5394 8.05685 10.6738 7.79695 10.7373 7.51607C10.8008 7.23519 10.7912 6.94273 10.7095 6.66661C10.6277 6.3905 10.4765 6.13996 10.2703 5.93894L7.73834 3.40494C7.40525 3.09954 6.96975 2.93011 6.51784 2.93011C6.06593 2.93011 5.63044 3.09954 5.29734 3.40494L3.57934 5.12294C1.86134 6.92994 3.76034 11.7229 8.01034 15.9719C12.2603 20.2209 17.0523 22.2109 18.8603 20.4019L20.5783 18.6839C20.8833 18.3508 21.0524 17.9154 21.0522 17.4637C21.052 17.0121 20.8826 16.5769 20.5773 16.2439Z",
    stroke: "white",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame10);
export default __webpack_public_path__ + "static/media/Frame (10).2ef0cf89.svg";
export { ForwardRef as ReactComponent };